import classNames from "classnames";
import React, { useState, useRef, useEffect } from "react";
import { Transition, CSSTransition } from "react-transition-group";

export interface IImageOptionDropdown {
    label: string;
    // children: any;
    cssWrapper?: string;
    cssButton?: string; //className suffix for <button> element
    isOpen?: boolean;
    options: any;
    onChange: (obj: string) => void;
}

export const ImageOptionDropdown = (props: IImageOptionDropdown) => {
    const wrapperRef = useRef(null);
    const { label, options } = props;
    const [isOpen, setIsOpen] = useState(props.isOpen);
    const [optionText, setOptionText] = useState(label);

    const handleClickOutside = () => {
        if (wrapperRef && !wrapperRef.current.contains(event.target)) setIsOpen(false);
    };

    const ToggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    const onDropdownOptionClick = (event: any) => {
        const clickedOption = event.currentTarget;
        const valueElement = clickedOption.querySelector(".item-value");
        setOptionText(valueElement.innerText);
        props.onChange(valueElement.innerText);
        setIsOpen(false);
    };

    useEffect(() => {
        document.addEventListener("touchstart", handleClickOutside);
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("touchstart", handleClickOutside);
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <div className={classNames("secondary-dropdown", props.cssWrapper)} ref={wrapperRef}>
            <button
                className={classNames("trigger", props.cssButton)}
                onClick={() => ToggleDropdown()}
                aria-expanded={isOpen}
                aria-haspopup="true"
            >
                <span className="text">{optionText}</span>
                <span className="icon" aria-hidden={true} />
            </button>

            <CSSTransition in={isOpen} timeout={300} unmountOnExit classNames="a-dropdown">
                <div className="dropdown-list" aria-hidden={!isOpen}>
                    <div className="dropdown-list-panel">
                        {options.map((o: any, index: any) => {
                            return (
                                <div key={index} className="item" onClick={onDropdownOptionClick}>
                                    {o.imgUrl ? (
                                        o.imgUrl == "All label" ? (
                                            <span className="item-placeholder">Sustainability Label</span>
                                        ) : (
                                            <img className="item-img" src={o.imgUrl} height={30} />
                                        )
                                    ) : (
                                        <span className="item-placeholder">All</span>
                                    )}
                                    {o.imgUrl ? (
                                        <span className="item-value sr-only">{o.value}</span>
                                    ) : (
                                        <span className="item-value sr-only">All</span>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                </div>
            </CSSTransition>
        </div>
    );
};
